import { useState, useEffect } from 'react';

export default function HeroSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/01a15fa13b83e36625d7b25c75440ecb.jpg',
      title: '岡山県の土木工事なら',
      subtitle: '地域密着20年の実績と信頼',
      description: '確かな技術と丁寧な施工で、安心・安全な工事をお約束いたします'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20newly%20paved%20asphalt%20road%20and%20water%20pipe%20infrastructure%20in%20Okayama%20city%20Japan%2C%20modern%20road%20construction%20results%2C%20clean%20smooth%20road%20surface%2C%20construction%20machinery%20in%20background%2C%20no%20people%2C%20bright%20daylight%2C%20professional%20quality%20civil%20engineering%20work%2C%20no%20text%20or%20signs%20visible&width=1920&height=800&seq=hero2new&orientation=landscape',
      title: '水道・舗装工事のプロ',
      subtitle: '岡山市・倉敷市を中心にサービス展開',
      description: '地域のインフラを支える確かな技術力でお応えします'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Completed%20modern%20urban%20infrastructure%20and%20road%20development%20in%20Okayama%20Japan%2C%20beautiful%20finished%20civil%20engineering%20project%2C%20clean%20modern%20road%20and%20construction%20results%2C%20construction%20equipment%20and%20machinery%2C%20no%20people%2C%20bright%20sunny%20environment%2C%20high%20quality%20professional%20workmanship%2C%20no%20text%20or%20signs%20visible&width=1920&height=800&seq=hero3new&orientation=landscape',
      title: '品質へのこだわり',
      subtitle: 'お客様満足度No.1を目指して',
      description: '丁寧な施工管理と確実な品質で、長く安心してお使いいただけます'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="relative h-[600px] md:h-[700px] overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div
            className="w-full h-full bg-cover bg-center relative"
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="absolute inset-0 bg-black/40"></div>
            <div className="relative z-10 h-full flex items-center">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                <div className="max-w-2xl text-white">
                  <h2 className="text-4xl md:text-6xl font-bold mb-4 leading-tight">
                    {slide.title}
                  </h2>
                  <h3 className="text-xl md:text-2xl mb-6 text-blue-200">
                    {slide.subtitle}
                  </h3>
                  <p className="text-lg md:text-xl mb-8 leading-relaxed">
                    {slide.description}
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4">
                    <a
                      href="tel:086-012-3456"
                      className="inline-flex items-center justify-center bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-phone-line mr-2"></i>
                      今すぐお電話
                    </a>
                    <a
                      href="#contact"
                      className="inline-flex items-center justify-center border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-mail-line mr-2"></i>
                      お問い合わせ
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-3 rounded-full transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-line text-xl"></i>
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-3 rounded-full transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-line text-xl"></i>
      </button>

      {/* Slide Indicators */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
              index === currentSlide ? 'bg-white' : 'bg-white/50'
            }`}
          />
        ))}
      </div>
    </section>
  );
}